module.exports = __webpack_public_path__ + "img/ai_tishi.9ecb05a2.png";